var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "#6d6e72",
    strokeOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60008 17.8588C10.2834 16.9315 12.1625 16.1576 13.9182 15.3798C16.9388 14.1058 19.9713 12.8538 23.0344 11.6882C23.6304 11.4896 24.7012 11.2954 24.8062 12.1786C24.7487 13.4288 24.5122 14.6716 24.35 15.9145C23.9382 18.6476 23.4623 21.3713 22.9982 24.0955C22.8383 25.0028 21.7016 25.4726 20.9742 24.8919C19.2263 23.7112 17.465 22.5421 15.7394 21.334C15.1741 20.7596 15.6983 19.9348 16.2031 19.5247C17.6427 18.1059 19.1695 16.9005 20.5339 15.4084C20.9019 14.5196 19.8145 15.2687 19.4558 15.4982C17.4849 16.8563 15.5623 18.2974 13.4844 19.4911C12.423 20.0753 11.1859 19.576 10.125 19.25C9.17372 18.8561 7.77979 18.4594 8.59999 17.8588L8.60008 17.8588Z",
    fill: "#6d6e72",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.524fd6629e11168e08e81111b66081f0.svg";
export { ForwardRef as ReactComponent };